module.exports = __webpack_public_path__ + "static/media/monitor-close.8f082c3f.svg";